import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Privilege } from '../models/privilege.model';
import { RoleService } from '../services/role.service';
@Component({
  selector: 'app-state',
  templateUrl: './state.component.html'
})
export class StateComponent {
  constructor(private service: RoleService, private router: Router) { }

  ngOnInit() {
    /*if (!this.service.isAuthorized(Privilege.State))
      this.router.navigate(['']);*/
  }
}
